import React from 'react';
import './AdminNavigationBar.css'; // Réutiliser le même style

function TeacherNavigationBar({ title, onBack, showBack = true }) {
  return (
    <div className="admin-nav-bar">
      <div className="nav-bar-content">
        {showBack && (
          <button className="back-button" onClick={onBack} title="Retour">
            <span className="back-arrow">←</span>
            <span className="back-text">Retour</span>
          </button>
        )}
        <h1 className="nav-bar-title">{title}</h1>
      </div>
    </div>
  );
}

export default TeacherNavigationBar;
